import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import styles from "../styles/integrations.module.scss";

import { Button } from "../shared/components/Button";
import { Title } from "../shared/components/Title";

import Adyen from "../assets/adyen.svg";
import ClearSaleLogo from "../assets/clearsale.png";
import Ecletica from "../assets/ecletica.png";
import FoodyDeliveryLogo from "../assets/foody-delivery.png";
import GoogleMaps from "../assets/google-maps.svg";
import GoogleTagManager from "../assets/google-tag-manager.svg";
import IfoodLogo from "../assets/ifood-logo.png";
import Mottu from "../assets/mottu.svg";
import Olga from "../assets/olga.svg";
import NetlogicLogo from "../assets/NetlogicLogo.png";
import OrdaticLogo from "../assets/ordatic.png";
import TotvsLogo from "../assets/totvs.png";
import MenewLogo from "../assets/menew.png";
import PagarMe from "../assets/pagar.me.svg";
import SafraPay from "../assets/safra-pay.svg";
import BeeDeliveryLogo from "../assets/bee-delivery.png";
import WooviLogo from "../assets/woovi.svg";
import SodeLogo from "../assets/sode.png";

import ROLES from "data/Roles";
import { useKonami } from "react-konami-code";
import {
  DrawerTypes,
  IntegrationDrawer,
} from "../shared/containers/Integrations/IntegrationDrawer";
import { AccessManager, Permissions } from "../shared/tools/AccessManager";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import { Storage } from "../shared/tools/Storage";
import { UserStorage } from "../shared/tools/UserStorage";
import { Hairline } from "@components";

const IntegrationType = {
  LOGISTICS: "LOGISTICS",
  IMPORTS: "IMPORTS",
  PAYMENT_ON_DELIVERY: "PAYMENT_ON_DELIVERY",
  GOOGLE: "GOOGLE",
  DATA: "DATA",
  ORDERS: "ORDERS",
  HIDDEN: "HIDDEN",
};

let userRole = UserStorage.getLoggedUser()?.role;

const integrations = {
  [IntegrationType.PAYMENT_ON_DELIVERY]: {
    name: "Pagamento online",
    items: [
      {
        name: "Pagar.me",
        description: "Integração com Pagar.me",
        path: null,
        drawer: DrawerTypes.PAGARME,
        logo: PagarMe,
        permissions: [Permissions.INTEGRATION_PAYMENT_PAGARME],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "Adyen",
        description:
          "Adyen é uma empresa de pagamentos holandesa que permite que empresas aceitem pagamentos por e-commerce, dispositivos móveis e pontos de venda.",
        path: null,
        drawer: DrawerTypes.ADYEN,
        logo: Adyen,
        permissions: [Permissions.INTEGRATION_PAYMENT_ADYEN],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "Safra Pay",
        description: "Integração com Safra Pay",
        path: null,
        drawer: DrawerTypes.SAFRAPAY,
        logo: SafraPay,
        permissions: [Permissions.INTEGRATION_PAYMENT_SAFRAPAY],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "ClearSale",
        description: "Integração com ClearSale",
        path: null,
        drawer: DrawerTypes.CLEARSALE,
        logo: ClearSaleLogo,
        permissions: [Permissions.INTEGRATION_PAYMENT_CLEARSALE],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "Woovi",
        description: "Integração com Woovi",
        path: null,
        drawer: DrawerTypes.WOOVI,
        logo: WooviLogo,
        permissions: [Permissions.INTEGRATION_PAYMENT_WOOVI],
        enabled: userRole === ROLES.SUPPORT,
      },
      {
        name: "Google Pay",
        description: "Integração com Google Pay",
        path: null,
        drawer: DrawerTypes.GOOGLE_PAY,
        logo: null,
        permissions: [Permissions.INTEGRATION_PAYMENT_WOOVI],
        enabled: userRole === ROLES.SUPPORT,
        allowedEnvironmentTypes: ["BRAND"],
      },
      {
        name: "Apple Pay",
        description: "Integração com Apple Pay",
        path: null,
        drawer: DrawerTypes.APPLE_PAY,
        logo: null,
        permissions: [Permissions.INTEGRATION_PAYMENT_WOOVI],
        enabled: userRole === ROLES.SUPPORT,
        allowedEnvironmentTypes: ["BRAND"],
      },
    ],
  },
  [IntegrationType.GOOGLE]: {
    name: "Google",
    items: [
      {
        name: "Google Maps (Marca)",
        description: "Integração com Google Maps API",
        drawer: DrawerTypes.GOOGLE_MAPS,
        logo: GoogleMaps,
        allowedEnvironmentTypes: ["BRAND"],
        permissions: [Permissions.INTEGRATION_GOOGLE_MAPS],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "Google Maps (Holding)",
        description: "Integração com Google Maps API",
        drawer: DrawerTypes.GOOGLE_MAPS_HOLDING,
        logo: GoogleMaps,
        allowedEnvironmentTypes: ["BRAND"],
        permissions: [Permissions.INTEGRATION_GOOGLE_MAPS],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "Google Tag Manager",
        description: "Integração com Google Tag Manager",
        drawer: DrawerTypes.GOOGLE_TAG_MANAGER,
        logo: GoogleTagManager,
        permissions: [Permissions.INTEGRATION_GOOGLE_TAG_MANAGER],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
    ],
  },
  [IntegrationType.LOGISTICS]: {
    name: "Logística",
    items: [
      {
        name: "IFood Entrega",
        description:
          "O iFood Entrega é uma solução que permite que você utilize a logística iFood vendendo em canais proprietários além do app.",
        path: null,
        drawer: DrawerTypes.IFOOD,
        logo: IfoodLogo,
        permissions: [Permissions.INTEGRATION_LOGISTICS_IFOOD],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "Mottu",
        description: "Integração com Mottu",
        path: null,
        drawer: DrawerTypes.MOTTU,
        logo: Mottu,
        permissions: [Permissions.INTEGRATION_LOGISTICS_MOTTU],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "Foody Delivery",
        description: "Integração com Foody Delivery",
        path: null,
        drawer: DrawerTypes.FOODY_DELIVERY,
        logo: FoodyDeliveryLogo,
        permissions: [Permissions.INTEGRATION_LOGISTICS_FOODY_DELIVERY],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "Bee Delivery",
        description: "Integração com Bee Delivery",
        path: null,
        drawer: DrawerTypes.BEE_DELIVERY,
        logo: BeeDeliveryLogo,
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "Soldado de Entrega",
        description: "Integração com Soldado de Entrega",
        path: null,
        drawer: DrawerTypes.SODE,
        logo: SodeLogo,
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
    ],
  },
  [IntegrationType.DATA]: {
    name: "Dados",
    items: [
      {
        name: "Olga",
        description: "Integração com OLGA",
        drawer: DrawerTypes.OLGA,
        logo: Olga,
        permissions: [Permissions.INTEGRATION_DATA_OLGA],
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
    ],
  },
  [IntegrationType.IMPORTS]: {
    name: "Importações",
    items: [
      {
        name: "Cardápio Ifood",
        description: "Importar um cardápio do Ifood",
        drawer: DrawerTypes.CATALOG_IFOOD,
        logo: IfoodLogo,
        enabled: [ROLES.SUPPORT, ROLES.ADMIN].includes(userRole),
      },
      {
        name: "Cardápio NetLogic",
        description: "Importar um cardápio da NetLogic",
        drawer: DrawerTypes.CATALOG_NETLOGIC,
        logo: NetlogicLogo,
        enabled:
          userRole === ROLES.SUPPORT ||
          userRole === ROLES.ADMIN ||
          userRole === ROLES.MANAGER,
      },
    ],
  },
  [IntegrationType.HIDDEN]: {
    name: "Integrações Ocultas",
    hidden: userRole !== ROLES.SUPPORT,
    items: [
      {
        name: "Eclética",
        description: "Integração com Eclética - PDV",
        drawer: DrawerTypes.ECLETICA,
        logo: Ecletica,
        enabled: true,
      },
      {
        name: "Conector NetLogic",
        description: "Integração com Oracle - PDV via NetLogic",
        drawer: DrawerTypes.NETLOGIC,
        logo: NetlogicLogo,
        enabled: true,
      },
      {
        name: "Ordatic",
        description: "Integração de cardápio e pedidos",
        drawer: DrawerTypes.ORDATIC,
        logo: OrdaticLogo,
        enabled: true,
      },
      {
        name: "Totvs",
        description: "Integração de pedidos",
        drawer: DrawerTypes.TOTVS,
        logo: TotvsLogo,
        enabled: true,
      },
      {
        name: "Menew",
        description: "Integração de pedidos",
        drawer: DrawerTypes.MENEW,
        logo: MenewLogo,
        enabled: true,
      },
      {
        name: "EasyAssist",
        description: "Integração de pedidos",
        drawer: DrawerTypes.EASYASSIST,
        logo: Olga,
        enabled: true,
      },
      {
        name: "Teknisa",
        description: "Integração de pedidos",
        drawer: DrawerTypes.TEKNISA,
        logo: Olga,
        enabled: true,
      },
      {
        name: "Saipos",
        description: "Integração de pedidos",
        drawer: DrawerTypes.SAIPOS,
        logo: Olga,
        enabled: true,
      },
      {
        name: "Atena.ai",
        description: "Integração de pedidos",
        drawer: DrawerTypes.ATENAAI,
        logo: Olga,
        enabled: true,
      },
      {
        name: "New Choice",
        description: "Integração de totem",
        drawer: DrawerTypes.SAIPOS,
        logo: Olga,
        enabled: true,
      },
      {
        name: "EyeMobile",
        description: "Integração de pedidos",
        drawer: DrawerTypes.EYEMOBILE,
        logo: Olga,
        enabled: true,
      },
      {
        name: "Bling",
        description: "Integração de pedidos",
        drawer: DrawerTypes.BLING,
        logo: Olga,
        enabled: true,
      },
      {
        name: "Twilio",
        description: "Validação OTP",
        drawer: DrawerTypes.TWILIO,
        logo: Olga,
        enabled: true,
      },
      {
        name: "Falaê",
        description: "Avalições de pedidos",
        drawer: DrawerTypes.FALAE,
        logo: Olga,
        enabled: true,
      },
    ],
  },
};

const hasGroupPermission = (integrationCategory) => {
  const integrationPermissions = [];
  integrationCategory.items.forEach((integration) => {
    integrationPermissions.push(...(integration.permissions || []));
  });

  if (integrationPermissions.length === 0) {
    return true;
  }

  return AccessManager.hasPermissions(integrationPermissions);
};

export const Context = () => {
  const environment = EnvironmentStorage.getEnvironment();

  let context;

  if (environment.brand)
    context = `${environment.brand.name} - ${environment.name}`;
  else context = environment.name;

  return (
    <>
      <div className={styles.context}>{context}</div>
      <Hairline className="mt-20" />
    </>
  );
};

export default function Integrations() {
  const [environment, setEnvironment] = useState({});
  const [showDrawer, setShowDrawer] = useState(false);
  const [isGodMode, setGodMode] = useState(UserStorage.isGodMode);

  useEffect(() => {
    const environment = EnvironmentStorage.getEnvironment();
    setEnvironment(environment);

    for (const key in integrations) {
      integrations[key].items = integrations[key].items.filter((i) => {
        const allowedEnvironmentTypes = i.allowedEnvironmentTypes || [];
        const isAllowed = allowedEnvironmentTypes.includes(environment.type);
        return allowedEnvironmentTypes.length === 0 || isAllowed;
      });
    }
  }, []);

  const konamiOptions = { code: [71, 79, 68, 77, 79, 68, 69] };
  useKonami(() => {
    if (!isGodMode && !showDrawer) {
      Storage.setItem("godMode", true);
      setGodMode(true);
    }
  }, konamiOptions);

  const getSubtitle = () => {
    if (environment?.brand)
      return (
        `${environment.brand.name} - ${environment.name}` +
        (environment.active === false ? " (Inativa)" : "")
      );
    return environment?.name;
  };

  const filteredIntegrations = Object.fromEntries(
    Object.entries(integrations).flatMap(([key, value]) => {
      const enabledItems = value.items.filter((item) => item.enabled);

      if (enabledItems.length === 0) {
        return [];
      }

      return [
        [
          key,
          {
            ...value,
            items: enabledItems,
          },
        ],
      ];
    })
  );

  return (
    <div className={styles.integrationsContainer}>
      <Title title="Integrações" subtitle={getSubtitle()} />

      {Object.keys(filteredIntegrations).map((key, index) => {
        if (filteredIntegrations[key].hidden && !isGodMode) {
          return null;
        }

        if (hasGroupPermission(filteredIntegrations[key]) === false) {
          return null;
        }

        return (
          <Fragment key={index}>
            <div className={styles.header}>
              <p>
                {filteredIntegrations[key].name} (
                {filteredIntegrations[key].items.length})
              </p>
            </div>

            <div className={styles.integrations}>
              {filteredIntegrations[key].items.map((integration, index) => {
                if (
                  integration.permissions &&
                  AccessManager.hasPermissions(integration.permissions) ===
                    false
                ) {
                  return null;
                }

                if (
                  (integration.hidden && !isGodMode) ||
                  !integration.enabled
                ) {
                  return null;
                }

                return (
                  <div className={styles.integration} key={index}>
                    <div className="d-flex align-center mb-25 w-100">
                      <div className={styles.logo}>
                        {integration.logo && (
                          <img src={integration.logo} alt={integration.name} />
                        )}
                      </div>
                      <div className="d-flex flex-column flex-1">
                        <p className={styles.name}>{integration.name}</p>
                        <span className={styles.description}>
                          {integration.description}
                        </span>
                      </div>
                    </div>

                    {integration.path && (
                      <Button design="underline">
                        <Link to={integration.path}>Ver mais</Link>
                      </Button>
                    )}
                    {integration.drawer && (
                      <Button
                        design="underline"
                        onClick={() => setShowDrawer(integration.drawer)}
                      >
                        Configurar
                      </Button>
                    )}
                  </div>
                );
              })}
            </div>
          </Fragment>
        );
      })}
      {showDrawer && (
        <IntegrationDrawer
          visible={showDrawer}
          integration={showDrawer}
          onClose={() => setShowDrawer(false)}
          onSave={() => setShowDrawer(false)}
        />
      )}
    </div>
  );
}
